import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FonteDadosListaComponent} from './fonte-dados-lista/fonte-dados-lista.component';
import {FonteDadosEdicaoComponent} from './fonte-dados-edicao/fonte-dados-edicao.component';
import { FonteDadosMonitorComponent } from './fonte-dados-monitor/fonte-dados-monitor.component';

const routes: Routes = [
  { path: 'fonteDados/listar', component: FonteDadosListaComponent, data: { titulo: 'Lista as Fonte de Dados' }  },
  { path: 'fonteDados/novo', component: FonteDadosEdicaoComponent, data: { titulo: 'Nova Fonte de Dados' } },
  { path: 'fonteDados/edicao/:id', component: FonteDadosEdicaoComponent, data: { titulo: 'Edição de Fonte de Dados' } },
  { path: 'fonteDados/monitor', component: FonteDadosMonitorComponent, data: { titulo: 'Monitoramento de Fonte de Dados' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FonteDadosRoutingModule { }
